import type { ReactElement } from 'react'
import styled from 'styled-components'

import { ImageTitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Detailed } from '@/components/pages/News/Machidukuri/Detailed'

export const MachidukuriPage = () => {
  return (
    <MachidukuriMain>
      <Detailed />
    </MachidukuriMain>
  )
}

MachidukuriPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: 'ニュースルーム', path: '/news/' },
    { name: '街づくりプロジェクト', path: '' },
  ]
  return (
    <Main>
      <Head
        title="街づくりプロジェクト"
        description="トライアルホールディングスは、「ALL JAPANでDXを推進する」、「博多ベイエリアを日本のシリコンバレーにする」というビジョンのもと、今後もあらゆる可能性を探っていきます。"
        ogp={{ url: 'news/machidukuri/' }}
      />
      <ImageTitleLayout
        title="トライアル　街づくりプロジェクト"
        subTitle="トライアル　街づくりプロジェクト"
        imgUrl="/images/news-machidukuri.jpg"
        breadCrumbs={breadCrumbs}
        isRequiredBackground={false}
      >
        {page}
      </ImageTitleLayout>
    </Main>
  )
}

const MachidukuriMain = styled.div`
  width: 1040px;
  margin: 0 auto;
  padding: 98px 0 130px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 0 20px 70px;
  }
`

const Main = styled.div`
  h2 {
    display: none; // 这将隐藏所有的 h2 标签
  }

  @media screen and (max-width: 1047px) {
    h2 {
      display: flex; // 这将隐藏所有的 h2 标签
    }
  }
`
